import { ReactComponent as IconGoogle } from "./svgs/google.svg";
import { ReactComponent as IconDefaultAvatar } from "./svgs/default-avatar.svg";

const Icons = {
  IconGoogle,
  IconDefaultAvatar,
};

export default Icons;
